export enum DocSignatureView {
  AGENT = "AGENT",
  CLIENT = "CLIENT",
}

export enum DocSignatureStatus {
  CREATED = "CREATED",
  SIGNED = "SIGNED",
}

export enum DocSignatureType {
  EMAIL = "EMAIL",
  MOBILE_APP = "MOBILE_APP",
}
